import { FC } from "react";
import { Button } from "@design-system/Button/Button";
import { HStack } from "@design-system/HStack/HStack";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";
import { Link } from "@design-system/Link/Link";
import { VStack } from "@design-system/VStack/VStack";
import { LeftArrowIcon, UploadIcon } from "@icons";
import containerStyles from "../../AddClientDrawerStepsContainer.module.scss";
import styles from "../AddClientDrawerSteps.module.scss";
import viewStyles from "./QboMigrationMethodView.module.scss";

interface Props {
    onConnect: () => void;
    onUpload: () => void;
    onBack: () => void;
}

export const QboMigrationMethodView: FC<Props> = ({
    onConnect,
    onUpload,
    onBack,
}) => (
    <div className={styles.container}>
        <div className={styles.header}>Migrate from QuickBooks Online</div>
        <div className={styles.subheader}>
            Connect QuickBooks to import your Chart of Accounts and history.
        </div>
        <VStack
            gap={12}
            align="center"
            className={styles.methodOptionsContainer}
        >
            <Button
                variant="primary"
                size="xl"
                type="button"
                onClick={onConnect}
                leftIcon={
                    <InstitutionIcon institution="quickbooks" size="xs" />
                }
            >
                Connect to QuickBooks
            </Button>
            <HStack gap={4} align="center" className={viewStyles.fallback}>
                Can't connect?
                <Link size="xs" leftIcon={<UploadIcon />} onClick={onUpload}>
                    Upload reports instead
                </Link>
            </HStack>
        </VStack>
        <div className={containerStyles.footer}>
            <Button
                variant="primary"
                type="button"
                onClick={onBack}
                iconOnly
                size="xl"
                aria-label="Go back"
            >
                <LeftArrowIcon />
            </Button>
        </div>
    </div>
);
